import React, { FC } from 'react'
import { Icon } from '@ui'
import css from './underActiveConstruction.module.scss'

export default function UnderActiveConstruction({ uri, small }: { uri: string; small?: boolean }) {
  return (
    <div className={css.container}>
      <IconWrapper small={small}>
        <Icon duotone name="construction" style={{ fontSize: small ? 34 : 68, color: '#ff5722' }} />
      </IconWrapper>
      <Label small={small}>
        <strong>{uri}</strong>
        <br /> is under active construction...
      </Label>
    </div>
  )
}

type LabelProps = {
  small?: boolean
}

const Label: FC<React.PropsWithChildren<LabelProps>> = ({ small, children }) => {
  return (
    <div className={css.container_label} style={{ fontSize: small ? 14 : 22 }}>
      {children}
    </div>
  )
}

type IconWrapperProps = {
  small?: boolean
}

const IconWrapper: FC<React.PropsWithChildren<IconWrapperProps>> = ({ small, children }) => {
  return (
    <div
      className={css.container_icon_wrapper}
      style={{
        padding: small ? 10 : '30px 20px',
        marginBottom: small ? 10 : 30,
        borderRadius: small ? 8 : 14,
      }}
    >
      {children}
    </div>
  )
}
